export const GET_NEW_OTHER_FEES = 'NEW_OTHER_FEES/get_new_other_fees';
export const GET_SINGLE_NEW_OTHER_FEES =
  'NEW_OTHER_FEES/get_single_new_other_fees';
export const UPDATE_NEW_OTHER_FEES = 'NEW_OTHER_FEES/update_new_other_fees';
export const CREATE_NEW_OTHER_FEES = 'NEW_OTHER_FEES/create_new_other_fees';
export const REMOVE_NEW_OTHER_FEES = 'NEW_OTHER_FEES/remove_new_other_fees';
export const GET_CEDULA_CALCULATION_LIST =
  'NEW_OTHER_FEES/get_cedula_calculation_list';
export const CEDULA_CALCULATION_INFO = 'NEW_OTHER_FEES/cedula_calculation_info';
export const CREATE_CEDULA_FEES = 'NEW_OTHER_FEES/create_cedula_fees';
export const UPDATE_CEDULA_FEES = 'NEW_OTHER_FEES/update_cedula_fees';
export const REMOVE_CEDULA_FEES = 'NEW_OTHER_FEES/remove_cedula_fees';
export const GET_VETERINARY_CALCULATION_LIST =
  'NEW_OTHER_FEES/get_veterinary_calculation_list';
export const CREATE_VETERINARY_FEES = 'NEW_OTHER_FEES/create_veterinary_fees';
export const UPDATE_VETERINARY_FEES = 'NEW_OTHER_FEE/update_veterinary_fees';
export const REMOVE_VETERINARY_FEES = 'NEW_OTHER_FEE/remove_veterinary_fees';
export const GET_FIRE_SAFETY_LIST = 'NEW_OTHER_FEES/get_fire_safety_list';
export const GET_FIRE_SAFETY_CALCULATION =
  'NEW_OTHER_FEES/get_fire_safety_calculation';
export const UPDATE_CALCULATION_FIRE_SAFETY =
  'NEW_OTHER_FEES/update_calculation_fire_safety';
export const GET_ENDORSING_OFFICES = 'NEW_OTHER_FEES/get_endorsing_offices';
export const GET_TAGGED_BUSINESS_LINES_LIST = 'NEW_OTHER_FEES/get_tagged_business_lines_list';
export const GET_REPORT_ACCESS = 'NEW_OTHER_FEES/get_report_access';

// zoning fees
export const CREATE_CALCULATION_ZONING_FEES =
  'CREATE_CALCULATION_ZONING_FEES/create_calculating_zoning_fees';
export const UPDATE_CALCULATION_ZONING_FEES =
  'UPDATE_CALCULATION_ZONING_FEES/update_calculating_zoning_fees';
export const REMOVE_CALCULATION_ZONING_FEES =
  'REMOVE_CALCULATION_ZONING_FEES/remove_calculating_zoning_fees';

export const FORM_DATA = {
  code: '',
  name: '',
  description: '',
  amount: '',
  percentage: '',
  type: '',
  for_new: 0,
  for_renewal: 0,
  endorsing_office_id: '',
  minimum_amount: '',
  maximum_amount: '',
  column_property: '',
  fee_type: '',
  for_retirement: 0,
  exclude_delinquent: 0,
};

export const CEDULA_FORM_DATA = {
  business_type: '',
  cedula_fixed_fee: '',
  cedula_base_fee: '',
  cedula_for_every_fee: '',
  cedula_additional_fee: '',
  cedula_max_fee: '',
};

export const VETERINARY_FORM_DATA = {
  veterinary_registration: '',
  amount: '',
  detail: '',
};

export const BUSINESS_TYPE = [
  { label: 'SOLE PROPRIETORSHIP', value: 'SOLE PROPRIETORSHIP' },
  { label: 'ONE PERSON CORPORATION', value: 'ONE PERSON CORPORATION' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'CORPORATION', value: 'CORPORATION' },
  { label: 'COOPERATIVE', value: 'COOPERATIVE' },
];

export const OTHER_FEE_TYPE = [
  { label: 'BARANGAY BUSINESS CLEARANCE', value: 'BARANGAY CLEARANCE' },
  { label: 'BASIC', value: 'BASIC' },
  { label: 'FIRE SAFETY', value: 'FIRE SAFETY' },
  { label: 'OPTION', value: 'OPTION' },
  { label: 'QUANTITY', value: 'QUANTITY' },
  // { label: 'QUANTITY MATRIX', value: 'QUANTITY MATRIX' },
  { label: 'RANGE', value: 'RANGE' },
  { label: 'VETERINARY', value: 'VETERINARY' },
  { label: 'ZONING', value: 'ZONING' },
  { label: 'ZONING PROCESSING', value: 'ZONING PROCESSING' },
];

export const FEE_TYPE = [
  { label: 'COMMON FEE', value: 'COMMON_FEE' },
  { label: 'SPECIFIC FEE', value: 'SPECIFIC_FEE' },
];
